
import React from 'react';
import PersonalizeIcon from '@material-ui/icons/TagFaces';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';

import {
    withRouter
} from 'react-router-dom'

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const PersonalizationAction = (props) => (
    <CardActions style={cardActionStyle}>
        <Button variant="outlined" aria-label="add" onClick={() => props.history.push(`/pages/${props.data.id}`)}>
            Personalize
        </Button>
    </CardActions>
);

export default withRouter(PersonalizationAction);


// WEBPACK FOOTER //
// ./src/pages/details/PersonalizationAction.js